import bannerImage from "../../../assets/images/placeholder-banner-min.png" ;
import "./intro-section.scss" ;

const IntroSection = (props) => {
    return (
        <section
            id="banner"
            style={{
                backgroundImage: `linear-gradient(to right,#000A,#0000), url(${bannerImage})`,
                backgroundPosition: "65%",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            className="position-relative"
        >
            <div
                className="d-flex flex-column flex-md-row container align-items-start align-items-md-center"
                style={{ minHeight: `calc(80vh - ${props.navHeight})` }}
            >
                <div className="mt-5 flex-md-fill mt-md-0 d-flex flex-column d-md-block align-items-start justify-content-end">
                    <h6 className="text-primary text-uppercase">intelligent compliance</h6>
                    <h1 className="mt-4 text-inverse">
                        They won't <br />
                        arrive with <br />
                        coffee and cakes
                    </h1>
                    <div className="h6 text-white text-uppercase" style={{ letterSpacing: "0" }}>
                        Watch Our Video to Learn More
                    </div>
                    {/* <button
                        onClick={props.onSubscribe}
                        className="btn px-5 py-3 btn-primary rounded-pill text-nowrap text-inverse text-btn mt-4"
                    >
                        Subscribe Now
                    </button> */}
                </div>
                <div className="video-button-container">
                    <div
                        style={{
                            width: "5rem",
                            height: "5rem",
                            boxShadow:"0 0 0 0.5rem #fff4",
                        }}
                        className="cursor-pointer text-primary rounded-circle bg-light d-flex align-items-center justify-content-center"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="44"
                            height="44"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="none"
                            fill="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7 4v16l13 -8z" />
                        </svg>
                    </div>
                    {/* <div className="mt-4 text-center rounded p-2" style={{maxWidth:"30ch",background:"rgba(0,0,0,0.5)"}}>
                        Watch our short video to see how easy compliance should be
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default IntroSection;
